<template>
  <div class="fixed bottom-5 left-0 p-4 flex flex-col gap-2 justify-center items-center">
    <ZoomControl v-if="!app.props.disablePanZoom" />
    <PanControl v-if="!app.props.disablePanZoom" />
  </div>
</template>

<script setup>
import Application from '@/core/application';
import { useState } from '@/store/useStore';
import PanControl from './PanControl.vue';
import ZoomControl from './ZoomControl.vue';
const app = Application.instance;

const { showMenu } = useState('seatmap');
</script>
